import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { GetProductsFromStore, GetProductsFromStoreVariables } from './types/GetProductsFromStore';

export const GET_PRODUCTS_FROM_STORE = gql`
  query GetProductsFromStore(
    $advertiserId: Int
    $endCursor: String
    $limit: Int
    $query: String
    $startCursor: String
  ) {
    getProductsFromStore(
      advertiserId: $advertiserId
      endCursor: $endCursor
      limit: $limit
      query: $query
      startCursor: $startCursor
    ) {
      products {
        currency
        title
        productId
        imageUrl
        price
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

interface UseGetProductsForStoreProps {
  advertiserId: number;
  limit?: number;
  searchQuery?: string;
  endCursor?: string;
  startCursor?: string;
}

export const useGetProductsForStore = ({
  advertiserId,
  limit,
  searchQuery,
  endCursor,
  startCursor
}: UseGetProductsForStoreProps) => {
  return useQuery<GetProductsFromStore, GetProductsFromStoreVariables>(
    GET_PRODUCTS_FROM_STORE,
    {
      variables: {
        advertiserId,
        limit,
        query: searchQuery,
        endCursor,
        startCursor
      },
      skip: !advertiserId
    }
  );
};
